/**
 * ReReportedBadge — small glossy 3D "Rr" pill shown beside a study's status when
 * the study has been re-reported (order_workflow.ow_re_reported).
 *
 * Shares the 3D shaded treatment of the ReportingNowBadge ("R" orb) so the two
 * reporting indicators read as a matched pair, but uses an amber tone (vs the
 * "R" badge's violet) to distinguish "re-reported" from "currently reporting".
 * Kept intentionally narrow so it still fits next to the status pill inside the
 * constrained status column.
 */
import React from 'react';
import { Tooltip } from 'antd';

export const ReReportedBadge: React.FC = () => (
  <Tooltip title="Re-reported">
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '18px',
        padding: '0 5px',
        borderRadius: '9px',
        // Glossy 3D amber pill — same top-lit gradient + inset highlights as the
        // violet "R" orb, in a different (amber) hue.
        background:
          'radial-gradient(circle at 50% 30%, #FBBF24 0%, #F59E0B 55%, #B45309 100%)',
        boxShadow:
          '0 1px 2px rgba(120, 53, 15, 0.4), inset 0 1px 1.5px rgba(255, 255, 255, 0.6), inset 0 -1.5px 2px rgba(120, 53, 15, 0.5)',
        color: '#fff',
        textShadow: '0 1px 1px rgba(0, 0, 0, 0.3)',
        fontFamily: 'Inter, sans-serif',
        fontWeight: 700,
        fontSize: '9.5px',
        lineHeight: '18px',
        letterSpacing: '0.2px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      Rr
    </span>
  </Tooltip>
);

export default ReReportedBadge;
